import { Skeleton } from 'antd';
import React from 'react';

const SpaceEditorSkeleton = () => {
  return (
    <div style={{ width: '100%' }}>
      <div className="editor__layout__actions" style={{ marginBottom: 8 }}>
        <div className="editor__layout__actions__inner" style={{ gap: 8, padding: '16px 12px' }}>
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton.Button active key={index} style={{ width: 95, height: 24 }} />
          ))}
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          width: '100%',
          maxWidth: 'var(--remirror-editor-width)',
          margin: 'auto',
          gap: 8,
          padding: '16px 12px',
        }}
      >
        <Skeleton.Input active size="large" style={{ width: '50%' }} />
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton.Input active size="small" style={{ width: '100%' }} key={index} />
        ))}
      </div>
    </div>
  );
};

export default SpaceEditorSkeleton;
